import React, { Fragment, useContext, useState, useEffect } from 'react';
import { Container, Row, Col,FormGroup,Label, Card, CardBody, Nav, NavItem, Form, NavLink, TabContent, TabPane, Input } from 'reactstrap';
import { Target, Info, CheckCircle, PlusCircle } from 'react-feather';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Breadcrumbs, Image, P, H4, H5, H6, Btn, DRTScrumbs } from '../../../AbstractElements';
import { ToastContainer, toast } from "react-toastify";
import page_icon from '../../../assets/images/drts_home/make_payment_ico.png';
import SvgIcon from '../../../Components/Common/Component/SvgIcon';
import { eServiceData } from './eServiceData';
import { drtsAPIURL } from '../../../Constant';
import { trackPromise } from 'react-promise-tracker';



const EServiceDetail = () => { 

  const history = useNavigate(); 
  const login = useState(JSON.parse(localStorage.getItem("login")))[0];
  const [eServiceDetails, setEServiceDetails] = useState({});
  const eServiceCode = window.location.pathname.split('/').pop();
  const params = useParams(); //alert("Code is: "+ params.eServiceCode+". Others are: "+JSON.stringify(params));

  const initialValues = { vehicle_reg_number: "",vehicle_owner_id: ""}

  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [isValidateSubmit, setIsValidateSubmit] = useState(false);
  const [isPaymentSubmit, setIsPaymentSubmit] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [isDRTSDataIn, setIsDRTSDataIn] = useState(false);

  const [isMenuHovering, setIsMenuHovering] = useState(false);
  const [isVehicleValidated, setIsVehicleValidated] = useState(false);
  const [validatedVehicleDetails, setValidatedVehicleDetails] = useState({});
  const [vehicle_reg_number, setVehicleRegNumber] = useState();
  const [vehicle_owner_id, setVehicleOwnerId] = useState();
  const [drts_api_msg, setDrtsApiMsg] = useState('');
  const [drts_api_msg_color, setDrtsApiMsgColor] = useState('red');


  const handleChange = (event) => {

    const { name, value } = event.target;

    if(event.target.name=="vehicle_reg_number") setVehicleRegNumber(event.target.value); 
    if(event.target.name=="vehicle_owner_id") setVehicleOwnerId(event.target.value);    

    setFormValues({ ...formValues, [name]: value });

    let parame=event.target.name;
    if (formErrors[parame]!=undefined&&formErrors[parame]!=null) delete formErrors[parame];
    setFormErrors(formErrors);

  }

  useEffect(() => { ///eServiceCode , eServiceData

   if(!login){
      toast.error("You must be logged in to access this eService. Please login or register."); 
      history(`${process.env.PUBLIC_URL}/eservices/login`);      
       }

  if(eServiceData!=null){

   let thisEservice = eServiceData.filter(eService => eService.code === eServiceCode);
  
    if(thisEservice.published!=undefined&&thisEservice.published=='false'){
       toast.error("This eService is not yet published! "); 
    }
   
     //alert(JSON.stringify(thisEservice));
     setEServiceDetails(thisEservice);
  

      }
      else {
        toast.error("Oops...! An unknown error occurred. Data could not be loaded."); 
      }

}, []);

const submitHandler = (e) => {

  e.preventDefault();
  
  setFormErrors(validate(formValues));

  setIsValidateSubmit(true);//isValidateSubmit

};

const submitPaymentHandler = (e) => {

  e.preventDefault();
  
  
      if(validatedVehicleDetails!=null&&validatedVehicleDetails.vehicle_fees!=undefined){

        setSubmitBtnDisabled(true);//alert(validatedVehicleDetails.eservice_code);

       let body=JSON.stringify({

        id: localStorage.getItem('user_id'),        
        //vehicle_reg_number: validatedVehicleDetails.vehicle_reg_number,
        eservice_code: validatedVehicleDetails.eservice_code,  
        eservice_data:validatedVehicleDetails.vehicle_fees.response,
        amount_paid:validatedVehicleDetails.vehicle_fees.response.total_amout,
        vehicle_fees:validatedVehicleDetails.vehicle_fees,

       /* owner_id: validatedVehicleDetails.owner_id,        
        levy_fee: validatedVehicleDetails.vehicle_fees.levy_fee,
        levy_revenue_type: validatedVehicleDetails.vehicle_fees.levy_revenue_type, 
        transaction_fee: validatedVehicleDetails.vehicle_fees.transaction_fee, 
        licence_document_type: validatedVehicleDetails.vehicle_fees.licence_document_type, 
        licence_revenue_type: validatedVehicleDetails.vehicle_fees.licence_revenue_type, 
        penalty_fee: validatedVehicleDetails.vehicle_fees.penalty_fee, 
        penalty_revenue_type: validatedVehicleDetails.vehicle_fees.penalty_revenue_type, 
        document_serial_number: validatedVehicleDetails.vehicle_fees.document_serial_number, 
        total_amout: validatedVehicleDetails.vehicle_fees.total_amout, 
        collection_office_code: validatedVehicleDetails.vehicle_fees.collection_office_code,  */

        });

        let token= localStorage.getItem('token');
       
       trackPromise(
            drtsApiRequest(drtsAPIURL+"initiate_payment",body,token,"proceed_to_pay_btn")
        ); 
      }
      else{
            toast.error("Ooops...! An internal error occurred. Try again shortly.");
      }

};



useEffect(() => {

  if (Object.keys(formErrors).length === 0 && isValidateSubmit) {

    setSubmitBtnDisabled(true);

       let body=JSON.stringify({
        id: localStorage.getItem('user_id'),        
        vehicle_reg_number: vehicle_reg_number,
        eservice_code: eServiceCode,  
        owner_id: vehicle_owner_id,            
        });

        let token= localStorage.getItem('token');
       
       trackPromise(
        drtsApiRequest(drtsAPIURL+"query_vehicle",body,token,"")
        );       
  }
else{

    if (Object.keys(formErrors).length > 0 && isSubmit) {
        toast.error("Please fill all the required fields. There are errors in your form.");
     }

     }

 }, [formErrors]);


const validate = (values) => {

   const errors = {};

   const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;    

   if (!values.vehicle_reg_number) {
        errors.vehicle_reg_number = "You must enter the Vehicle Registration Number";
   }

   if (!values.vehicle_owner_id) {
       errors.vehicle_owner_id = "You must enter Omang/Passport Number of the vehicle owner. Omang for citizens and passport number for foreigners.";
   }

    
return errors;

};



async function drtsApiRequest(url,body,token,eng) {
try {
await fetch(url, {
  method: 'POST',
  headers: {
    'Authorization': `Bearer ${token}`,
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
  body: body,
})
  .then((response) => {

    if (response.ok) {
      //console.log('hh8 -- '+JSON.stringify(respose))
      return response.json()
    }
    else{
      return response.json().then(text => { 
        //throw new Error(text) 
        if(text.message!=undefined){
        toast.error("Request failed: "+text.message);
        }
        else{
          toast.error("Request failed: Could not connect to the server");  
        }
      });
    }
  })
  .then((data) => {
   
    setSubmitBtnDisabled(false);
  
    if (data.status!=null&&data.status==true&&data.status!=undefined) {

     
     
      if(eng=='proceed_to_pay_btn'){

        localStorage.setItem('validatedVehicleDetails', validatedVehicleDetails);
               
        post_payment_details(data.pay_url, data.payment_data);

      }
      else{
      setValidatedVehicleDetails(data);//alert("set: "+JSON.stringify(data));
      setIsVehicleValidated(true);
        //alert(JSON.stringify(data));
      setIsDRTSDataIn(true);
      }

      toast.success(data.message); 
      setDrtsApiMsg(data.message);
      setDrtsApiMsgColor('green');

    } else {

      setIsDRTSDataIn(false);
      setIsVehicleValidated(false);

      if (data.status!=null&&data.status!=undefined) {
        toast.error("Error: "+data.message);
        setDrtsApiMsg(data.message);
        }
     else{
       toast.error("Ooops! An unexpected error occurred. Try again shortly.");
       setDrtsApiMsg("Ooops! An unexpected error occurred. Try again shortly.");
       }       
      
      setDrtsApiMsgColor('red');
    }
  })
} catch (error) {
  setSubmitBtnDisabled(false);
  setIsDRTSDataIn(false);
  setIsVehicleValidated(false);
   //console.log(JSON.stringify(error));
   toast.error("Oops...An error occurred!");
   setDrtsApiMsg("Oops...An error occurred! "+JSON.stringify(error));
   setDrtsApiMsgColor('red');
}
}




function post_payment_details(path, params) {

  let method='post';
  // The rest of this code assumes you are not using a library.
  // It can be made less verbose if you use one.
  const form = document.createElement('form');
  form.method = method;
  form.action = path;

  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const hiddenField = document.createElement('input');
      hiddenField.type = 'hidden';
      hiddenField.name = key;
      hiddenField.value = params[key];

      form.appendChild(hiddenField);
    }
  }

  document.body.appendChild(form);
  form.submit();
}



  return (
    <Fragment>
      {/*<Breadcrumbs />*/}
      <Container fluid={true}>

      <Row className="project-card" style={{width:"100%",textAlign:"center", padding:10, borderRadius: "0.7rem", margin:10}}>
          <Col md="12" className="project-list" style={{width:"100%",textAlign:"center", margin:0, padding:0, borderRadius: "0.7rem", backgroundColor:"#ffffff"}}>            
           
             <Row style={{textAlign:"center", padding:0, width:"100%", margin:0}}>
            
          <Col md='1' style={{textAlign:"center", width:"5%", backgroundColor:"#ffffff",padding:0, borderRadius: "0.7rem", margin:0}}>{" "}
          </Col>
          <Col md='10' style={{textAlign:"center", width:"90%", backgroundColor:"#ffffff", padding:0, borderRadius: "0.7rem", margin:0}}>			 
           
               {eServiceDetails[0]!=null? <DRTScrumbs parent="Home" title="eService" mainTitle={eServiceDetails[0].title.toUpperCase()} /> :" DRTS ESERVICES"}          
          
          </Col>

          <Col md='1' style={{textAlign:"center", width:"5%", backgroundColor:"#ffffff", padding:0, borderRadius: "0.7rem",margin:0}}>{" "} 
          </Col>

          </Row>    

          </Col>
        </Row>
  
		
		 <Row className="project-card">
          <Col md="12" className="project-list">
            <Card>
              <Row style={{width:"100%"}}>
                <Col md="3" style={{ width:"20%", textAlign:"center" , overflow: 'hidden', borderRadius:"1rem"}}>
                
                 <Image attrImage={{ src: `${page_icon}`, 
                 alt: 'Welcome to DRTS Web Portal', width:180, 
                 border: '1px solid white', borderRadius:"1rem", textAlign: "center", margin:0, overflow: 'hidden' }} />
                           
                </Col>
				
				        <Col md="9" style={{width:"80%", backgroundColor:"#ffffff"}}>

{/*#dee2e675*/}
         <Row>
          <Col md="12" >
            <Card style={{backgroundColor:"#dee2e69c"}}>   
              
              <CardBody >
                
                <Nav tabs className="border-tab" >                    
                      <NavItem 
                      ><NavLink style={{backgroundColor:"#dee2e675", width:"100%", textAlign:"left"}}>
                        { eServiceDetails[0]!=null && eServiceDetails[0].published=='false'? ( 
                        <H6>{"Notice"}</H6>):(
                          eServiceDetails[0]!=null? (
                            isVehicleValidated? (<H6>{"Vehicle Fees Confirmation"}</H6>
                             ):(<H6>{"Eligibility Terms"}</H6>)):(<span>{"Internal Error"}</span>)
                        )}
                        
                        </NavLink></NavItem>                    
				        </Nav>

                  <div style={{backgroundColor:"#dee2e69c", marginLeft:5, minWidth: "300px", textAlign:'left', width:'100%', border: '1px solid #dee2e69c', borderRadius:"0.7rem", color:'#888888', align:'left'}}>
                       {eServiceDetails[0]!=null && eServiceDetails[0].published=='true'? ( 
                        <span>
                        {eServiceDetails[0].code=='2025001'? (
                         isVehicleValidated? (<span></span>):(  <span>
                             {"The vehicle must not be flagged, scrapped or deregistered"}
                               <br />
                             {"You can renew the vehicle even if it's not your own."}
                           </span>)
                          ):(<span></span>)}

                       </span>
                         ):( <span> {"This eService is not yet published. Check back soon!"}</span>) }          
                  </div>
                

              </CardBody>
            </Card>
          </Col>
        </Row>

      {eServiceDetails[0]!=null&&eServiceDetails[0].code=='2025001'? ( 

        isVehicleValidated? (

          validatedVehicleDetails !=null? (

          <Row>
          <Col md="12">
            <Card>
              
              <CardBody>
          <Row >

          <div >
          <Form className="theme-form"  onSubmit={submitPaymentHandler}>

            
                     <Nav tabs className="border-tab">                    
                       <NavItem><NavLink className={'active'} >
                        <H6>{"Vehicle Registration/Plate Number:"}</H6>                        
                       </NavLink></NavItem><span style={{position:"relative",top:-2}}>{validatedVehicleDetails.vehicle_reg_number}</span> 
                       </Nav><Nav tabs className="border-tab">

                       <NavItem><NavLink className={'active'} >
                        <H6>{"Penalty Fee:"}</H6>                        
                       </NavLink></NavItem> <span style={{position:"relative",top:-2}}>{"P"}{validatedVehicleDetails.vehicle_fees.response.penalty_fee}</span>
                       </Nav><Nav tabs className="border-tab">

                       <NavItem><NavLink className={'active'} >
                        <H6>{"Levy:"}</H6>
                       </NavLink></NavItem> <span style={{position:"relative",top:-2}}>{"P"}{validatedVehicleDetails.vehicle_fees.response.levy_fee}</span>
                       </Nav><Nav tabs className="border-tab">

                       <NavItem><NavLink className={'active'} >
                        <H6>{"Service Fee:"}</H6>                       
                       </NavLink></NavItem> <span style={{position:"relative",top:-2}}>{"P"}{validatedVehicleDetails.vehicle_fees.response.transaction_fee}</span>
                       </Nav><Nav tabs className="border-tab">
                        
                        <NavItem><NavLink className={'active'} >
                        <H6>{"TOTAL PAYABLE:"}</H6>
                        
                       </NavLink></NavItem> <span style={{position:"relative",top:-2}}>{"P"}{validatedVehicleDetails.vehicle_fees.response.total_amout}</span> 

			              </Nav>
               
  <FormGroup>
    <Input name="validatedVehicleDetails" className="form-control input_bodara" type="hidden"  value={validatedVehicleDetails} 
    
    />   
  </FormGroup>
    
  <div className="position-relative form-group mb-0">
    
                  <Btn 
                   style={{  paddingRight:0,  paddingBottom:0,backgroundColor: isMenuHovering ? '#f97d2b' :"primary" }} 
                   attrBtn={{ color: "primary", className: "d-block w-100 mt-2", 
                   backgroundColor: isMenuHovering ? '#f97d2b' :"primary" }}
                   onMouseEnter={() => setIsMenuHovering(true)}
                   onMouseLeave={() => setIsMenuHovering(false)}><b>{"Proceed to Pay"}</b>
                   </Btn>
  </div>

</Form>
</div>

        </Row>
                

              </CardBody>
            </Card>
          </Col>
        </Row>):(<span>{"No data to show!"}</span>)
        ):( <Row>
          <Col md="12">
            <Card>
              
              <CardBody>

        <Row >
        <span style={{ color: drts_api_msg_color }}>{drts_api_msg}</span>
        <div >

<Form className="theme-form"  onSubmit={submitHandler}>

<Row className='header-wrapper m-0'>   
                     <Nav tabs className="border-tab">                    
                       <NavItem><NavLink className={'active'} ><H6>{"Enter Vehicle Registration/Plate Number"}</H6></NavLink></NavItem>                    
			              </Nav>
                </Row>
  <FormGroup>
    <Input name="vehicle_reg_number" className="form-control input_bodara" type="text" onChange={handleChange} value={vehicle_reg_number} 
     style={{ border:"1px solid #3a35355e"}} 
    />
    <span style={{ color: 'red' }}>{formErrors.vehicle_reg_number}</span>
  </FormGroup>
  
  <FormGroup>
                     <Nav tabs className="border-tab">                    
                       <NavItem><NavLink className={'active'} ><H6>{"Enter Owner Omang/Passport Number"}</H6></NavLink></NavItem>                    
			              </Nav>
               
  
    <Input name="vehicle_owner_id" className="form-control input_bodara" type="text" onChange={handleChange} value={vehicle_owner_id} 
     style={{ border:"1px solid #3a35355e"}} 
    />
    <span style={{ color: 'red' }}>{formErrors.vehicle_owner_id}</span>
  </FormGroup>

    
  <div className="position-relative form-group mb-0">
    
                  <Btn 
                   style={{  paddingRight:0,  paddingBottom:0,backgroundColor: isMenuHovering ? '#f97d2b' :"primary" }} 
                   attrBtn={{ color: "primary", className: "d-block w-100 mt-2", 
                   backgroundColor: isMenuHovering ? '#f97d2b' :"primary" }}
                   onMouseEnter={() => setIsMenuHovering(true)}
                   onMouseLeave={() => setIsMenuHovering(false)}>{"Submit"}
                   </Btn>
  </div>

</Form>
</div>

        </Row>
                

              </CardBody>
            </Card>
          </Col>
        </Row>)):( <span> </span>)}
                      
                                 

                </Col>
               
              </Row>
            </Card> 
          </Col>
                  
        </Row>
		
		
		
		
		
		
      </Container>
    </Fragment>
  );
};

export default EServiceDetail;